function clone(value: unknown, seen: WeakMap<object, unknown>): unknown {
  if (value === null || value === undefined) {
    return value;
  }
  if (typeof value !== 'object') {
    return value;
  }

  if (value instanceof Date) {
    return new Date(value.getTime());
  }
  if (value instanceof RegExp) {
    return new RegExp(value.source, value.flags);
  }
  if (value instanceof Map) {
    if (seen.has(value)) {
      return seen.get(value);
    }
    const result = new Map();
    seen.set(value, result);
    value.forEach((mapValue, mapKey) => {
      result.set(clone(mapKey, seen), clone(mapValue, seen));
    });
    return result;
  }
  if (value instanceof Set) {
    if (seen.has(value)) {
      return seen.get(value);
    }
    const result = new Set();
    seen.set(value, result);
    value.forEach((setValue) => {
      result.add(clone(setValue, seen));
    });
    return result;
  }
  if (value instanceof URLSearchParams) {
    return new URLSearchParams(value);
  }
  if (Array.isArray(value)) {
    if (seen.has(value)) {
      return seen.get(value);
    }
    const result: unknown[] = [];
    seen.set(value, result);
    value.forEach((item, index) => {
      result[index] = clone(item, seen);
    });
    return result;
  }

  if (seen.has(value)) {
    return seen.get(value);
  }

  const result: Record<string, unknown> = {};
  seen.set(value, result);
  Object.keys(value).forEach((key) => {
    result[key] = clone((value as Record<string, unknown>)[key], seen);
  });
  return result;
}

export default function deepClone<T>(value: T): T {
  return clone(value, new WeakMap()) as T;
}
